import { call, put, takeLatest, all } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post } from "../../../../helpers/api_helper";

// 🚀 Fetch Saga
function* fetchTaxSaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_PAYROLL_DEDUCTION_FETCH_TAX, formData);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch Tax!');
    }

    yield put({ type: types.PAYROLL_DEDUCTION_FETCH_TAX_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while fetching!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.PAYROLL_DEDUCTION_FETCH_TAX_FAILURE, payload: error });
  }
}

// 💾 Save Saga
function* saveTaxSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_PAYROLL_DEDUCTION_SAVE_TAX, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save Tax!');
    }

    Swal.fire({ title: "Success", text: response.message, icon: "success", confirmButtonText: "OK", });
    yield put({ type: types.PAYROLL_DEDUCTION_SAVE_TAX_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire({ title: 'Error', text: error.message || 'Something went wrong while saving!', icon: 'error', confirmButtonText: 'OK', });
    yield put({ type: types.PAYROLL_DEDUCTION_SAVE_TAX_FAILURE, payload: error });
  }
}

// 🔄 Change Status Saga
function* changeTaxStatusSaga(action) {
  try {

    const response = yield call(post, process.env.REACT_APP_PAYROLL_DEDUCTION_CHANGE_TAX_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to change status!');
    }

    yield put({ type: types.PAYROLL_DEDUCTION_CHANGE_TAX_STATUS_SUCCESS, payload: response });
    Swal.fire('Success', 'Status updated!', 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while updating status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.PAYROLL_DEDUCTION_CHANGE_TAX_STATUS_FAILURE, payload: error });
  }
}

// 🔄 Root Saga
export default function* taxSaga() {
  yield all([
    takeLatest(types.PAYROLL_DEDUCTION_FETCH_TAX, fetchTaxSaga),
    takeLatest(types.PAYROLL_DEDUCTION_SAVE_TAX, saveTaxSaga),
    takeLatest(types.PAYROLL_DEDUCTION_CHANGE_TAX_STATUS, changeTaxStatusSaga),
  ]);
}
